/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ q: NonNullable<unknown> }} Palette_See_AllInputs */

const en_palette_see_all = /** @type {(inputs: Palette_See_AllInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`See all results for “${i?.q}”`)
};

/**
* | output |
* | --- |
* | "See all results for “{q}”" |
*
* @param {Palette_See_AllInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const palette_see_all = /** @type {((inputs: Palette_See_AllInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Palette_See_AllInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_palette_see_all(inputs)
});